<template>
  <img src="/assets/images/tooltip.svg"
       alt=""
       class="hover-tooltip"
       v-tooltip="{content: $props.content, trigger: 'click hover'}">
</template>

<script>
export default {
  name: 'hover-tooltip',
  props: {
    content: String
  }
}
</script>

<style scoped>
.hover-tooltip {
  width: 1.4rem;
  height: 1.4rem;
}
</style>
